<template>
  <v-select
    :items="dealStatusList"
    item-value="id"
    item-text="name"
    v-model="idValue"
    :label="label || 'Status'"
    :rules="[requiredCheck()]"
    :clearable="true"
    outlined
  ></v-select>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { required } from '@/lib/formValidations'

export default {
  props: [
    'id',
    'isRequired',
    'label'
  ],
  computed: {
    ...mapFields('dealStatuses', [
      'dealStatusList'
    ]),
    idValue: {
      get () {
        return this.id
      },
      set (newValue) {
        this.$emit('change', newValue)
      }
    }
  },
  methods: {
    ...mapActions('dealStatuses', [
      'getDealStatuses'
    ]),
    requiredCheck () {
      return !this.isRequired || required('Deal status')
    }
  },
  created () {
    this.getDealStatuses()
  }
}
</script>
